
export const ROLE_OPTIONS = [
  { value: '', label: 'All Roles' },
  { value: 'instructor', label: 'Instructor' },
  { value: 'studio-owner', label: 'Studio Owner' }
];

export const STATUS_OPTIONS = [
  { value: '', label: 'All Status' },
  { value: 'pending', label: 'Pending' },
  { value: 'approved', label: 'Approved' },
  { value: 'rejected', label: 'Rejected' }
];

export const SORT_VALUES = {
  NEWEST: '',
  OLDEST: 'oldest',
  NAME_ASC: 'name_asc',
  NAME_DESC: 'name_desc',
  PENDING_FIRST: 'pending_first',
};

export const SORT_OPTIONS = [
  { value: SORT_VALUES.NEWEST, label: 'Newest First' },
  { value: SORT_VALUES.OLDEST, label: 'Oldest First' },
  { value: SORT_VALUES.NAME_ASC, label: 'Name (A-Z)' },
  { value: SORT_VALUES.NAME_DESC, label: 'Name (Z-A)' },
  { value: SORT_VALUES.PENDING_FIRST, label: 'Pending First' },
];

export const ACTION_BUTTONS = [
  {
    title: 'Approve',
    status: 'approved',
    backgroundColor: '#4caf50',
  },
  {
    title: 'Reject',
    status: 'rejected',
    backgroundColor: '#f44336',
  },
  {
    title: "Request More Information",
    status: "info",
    backgroundColor: "#3B82F6"
  }
];

export const STATUS = {
  PENDING: 'pending',
  APPROVED: 'approved',
  REJECTED: 'rejected',
  GET_INFO: 'info'
};